export default __webpack_public_path__ + "static/media/adscreen-half-height_2.jpg";